<template>
  <div class="row" :class="classes" :style="{ ...styles, ...cssVars }">
    <template v-for="field in fields">
      <componentRenderer
        :class="`col-lg-${getColumns(field)}`"
        :field="field"
        v-bind:key="field.id"
        v-on:component-updated="updated"
      />
    </template>
  </div>
</template>
<script>
import componentRenderer from "@/components/component-renderer";

export default {
  name: "empty-bucket",
  components: {
    componentRenderer
  },
  data: () => {
    return {
      hasMediaQuery: false,
      test: {}
    }
  },
  props: {
    fieldId: String,
    requires: Array,
    fields: {
      type: Array,
      required: true
    },
    grid: {
      type: Object
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    classes: {
      type: String
    }
  },
  methods: {
    getColumns (field) {
      return field.properties && field.properties.grid
        ? field.properties.grid.columns
        : 12;
    },
    updated (field, properties) {
      let updatedField = this._.find(this.fields, function (fld) {
        return fld.fieldId === field.fieldId;
      });

      updatedField.properties = { ...updatedField.properties, ...properties };
      // let updatedField = __.findDeep(this.fields, fld => fld === field.fieldId);
      // console.log(
      //   "component renderer on updated::",
      //   field,
      //   "properties",
      //   properties,
      //   "FOUND",
      //   updatedField
      // );

      // TODO
      // some validation will go here
      // in case if all fields are valid we are happy to set truthy status
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
    }
  }
};
</script>
<style scoped lang="scss">
.row {
  /deep/ [disabled] {
    opacity: 0.65;
    pointer-events: none;
  }
}

.receiptUploader {
  @media (max-width: 450px) {
    padding: 0px;
  }
}

.mobile_background {
  @media (max-width: 450px) {
    flex-direction: column !important;
    align-items: center !important;
  }
  padding: 50px 0px 50px 0px !important;
  margin: 0px;
}

.form-wrapper {
  background: #F5FAFF;
  border-radius: 8px;
  padding: 48px;
  @media (max-width: 767px) {
    padding: 20px;
  }
}

.form-top-wrapper {
  background: #FFFFFF;
  box-shadow: 0px 16px 32px -3px #EBEBEB;
  border-radius: 16px;
  padding: 32px;
  @media (max-width: 767px) {
    padding: 15px;
  }
}

</style>
